/* ---- MAINTAIN ONLINE LIST AND UNREAD NOTIFICATIONS UPDATED START ---- */
export default {
	unreadActivitiesData: {},
	readActivityIds: [],
	setReadQueue: [],
	fetchedInPhaseNumer: null,
	pullActivitiesQueue: [],
	setUnreadStatesTimeout: null,

	fetchAllUnreadActivities: () => {
		if (
			pp.currentActorId === undefined ||
			pp.gameState.phaseNumber === undefined ||
			pp.activities.fetchedInPhaseNumer == pp.gameState.phaseNumber
		) {
			return;
		}

		pp.log("ACTIVITIES fetchAllUnreadActivities");

		// Make a copy so that pp.activities.readActivityIds won't be concatenated
		let toOmit = Object.assign([], pp.activities.readActivityIds);
		toOmit = toOmit.concat(pp.activities.setReadQueue);

		pp.activities.pullActivities({
			omit_activity_ids: toOmit,
			omit_displaying_dismissable_notices: true,
		});
		pp.activities.fetchedInPhaseNumer = pp.gameState.phaseNumber;
	},

	setPullActivityTimeout: () => {
		if (pp.activities.pullActivitiesTimeout !== undefined) {
			return;
		}
		pp.activities.pullActivitiesTimeout = setTimeout(() => {
			pp.activities.pullActivities({ include_annulled_activities: true });
		}, 300);
	},

	pullActivities: (optionsHash = {}) => {
		optionsHash.activity_ids = pp.activities.pullActivitiesQueue;
		$.ajax({
			type: "GET",
			url: "/activities/render_activities",
			dataType: "script",
			data: optionsHash,
		});
		pp.activities.pullActivitiesQueue.splice(
			0,
			pp.activities.pullActivitiesQueue.length,
		); // Empty the queue
		pp.activities.pullActivitiesTimeout = undefined;
	},

	addToUnreadState: (activityId, navbarPath, nestedLinksToMark = []) => {
		// pp.log("ACTIVITIES adding Activity as unread -- Activity id, navbar path, sub links to mark", activityId, navbarPath, nestedLinksToMark);

		if (
			// @ts-expect-error
			pp.activities.readActivityIds.includes(activityId) ||
			// @ts-expect-error
			pp.activities.setReadQueue.includes(activityId)
		) {
			// pp.log("ACTIVITIES aleady read id:", activityId);
			return;
		}

		let newHash = Object.assign({}, pp.activities.unreadActivitiesData); // Copy object

		// Remove entry from hash if present
		if (
			Object.keys(newHash).includes(activityId) ||
			Object.keys(newHash).includes(String(activityId))
		) {
			pp.log(
				"overwriting properties for same Activity:",
				activityId,
				newHash[activityId],
			);
		}

		newHash[activityId] = {
			navbarPath: navbarPath,
			nestedLinksToMark: nestedLinksToMark,
		};
		pp.activities.unreadActivitiesData = newHash;
	},

	debounceUnreadStates: (oldval, newval) => {
		if (pp.activities.setUnreadStatesTimeout !== null) {
			clearTimeout(pp.activities.setUnreadStatesTimeout);
		}
		// @ts-expect-error
		pp.activities.setUnreadStatesTimeout = setTimeout(() => {
			pp.activities.setNavbarUnreadStates(newval);
			pp.activities.setNestedLinksUnreadStates(newval);
			pp.activities.setUnreadStatesTimeout = null;
		}, 50);
	},

	setNavbarUnreadStates: (unreadActivitiesData) => {
		pp.log(
			"ACTIVITIES into setNavbarUnreadStates -- unreadActivitiesData",
			unreadActivitiesData,
			pp.activities.unreadActivitiesData,
		);

		// Remove all the unread marks from the navbar elems (NB `navbar-header`) is not a `li`
		$("nav.navbar, .BottomNav__main-nav")
			.find("li.unread, div.navbar-header.unread")
			.each((idx, navbarElem) => {
				$(navbarElem).removeClass((index, classNames) => {
					return (classNames.match(/unread-?\d*/g) || []).join(" ");
				});
			});

		unreadActivitiesData =
			unreadActivitiesData || pp.activities.unreadActivitiesData;
		if (unreadActivitiesData === undefined) {
			return;
		}

		let unreadCountPerNavbarElem = {};
		let mobileNavHiddenSum = 0;

		// Collect how many unread Activities there are per navbar url
		$.each(unreadActivitiesData, (activityId, props) => {
			if (unreadCountPerNavbarElem[props.navbarPath] === undefined) {
				unreadCountPerNavbarElem[props.navbarPath] = 0;
			}
			unreadCountPerNavbarElem[props.navbarPath] += 1;
		});

		$.each(unreadCountPerNavbarElem, (href, unreadCount) => {
			$("nav.navbar, .BottomNav__main-nav")
				.find(`a[href='${href}']:not(.disabled)`)
				.each((index, navbarElem) => {
					$(navbarElem)
						.parent()
						.addClass(`unread unread-${unreadCount > 9 ? "10" : unreadCount}`);

					if ($(navbarElem).parents(".BottomNav__main-nav--tray").length) {
						mobileNavHiddenSum += unreadCount;
					}
				});
		});

		if (!mobileNavHiddenSum) {
			// I.e. if length == 0
			return;
		}
		$(".BottomNav__main-nav--tray-toggle")
			.parent()
			.attr(
				"class",
				`unread unread-${mobileNavHiddenSum > 9 ? "10" : mobileNavHiddenSum}`,
			);
	},

	setNestedLinksUnreadStates: (unreadActivitiesData) => {
		unreadActivitiesData =
			unreadActivitiesData || pp.activities.unreadActivitiesData;
		const currentPathName =
			$("nav.navbar, .BottomNav__main-nav")
				.find("li.active a")
				.first()
				.attr("href") || window.location.pathname;
		// pp.log("ACTIVITIES into setNestedLinksUnreadStates -- unreadActivitiesData, currentPathName", unreadActivitiesData, currentPathName);
		if (unreadActivitiesData === undefined) {
			return;
		}

		$.each(unreadActivitiesData, (activityId, props) => {
			if (
				props.navbarPath != currentPathName ||
				!props.nestedLinksToMark.length
			) {
				return; // `continue` for jQuery
			}
			// @ts-expect-error
			activityId = parseInt(activityId, 10); // Is inserted into the loop as a string

			props.nestedLinksToMark.forEach((arrayItem, idx) => {
				let requiredParentSelector = "body";
				let nestedElemSelector;
				if (typeof arrayItem === "object") {
					// Expect a hash with exactly one key
					// @ts-expect-error
					requiredParentSelector = Object.keys(arrayItem)[0];
					nestedElemSelector = Object.values(arrayItem)[0];
				} else {
					nestedElemSelector = arrayItem;
				}

				// pp.log("- selectors:", requiredParentSelector, nestedElemSelector);
				let $dropdownListElem;
				if (nestedElemSelector.indexOf("$(") != -1) {
					if (requiredParentSelector != "body") {
						console.error(
							"Can't use a stringified jQuery selector with a specific `requiredParentSelector`!",
						);
					}
					$dropdownListElem = eval(nestedElemSelector);
				} else if (nestedElemSelector.indexOf("/") == 0) {
					// For the case where the selector is a link (e.g. '/drafts/123')
					$dropdownListElem = $(
						`${requiredParentSelector} a[href='${nestedElemSelector}']`,
					).closest("li");
				} else {
					// For the case where the selector is anything else
					$dropdownListElem = $(
						`${requiredParentSelector} ${nestedElemSelector}`,
					).closest("li, a[data-toggle='collapse']");
				}

				if (!$dropdownListElem.length) {
					return;
				}
				let elementsToMark = [$dropdownListElem];
				if (requiredParentSelector != "body") {
					elementsToMark = elementsToMark.concat($(requiredParentSelector));
				}
				elementsToMark.forEach(($elem) => {
					let thisData = pp.activities.arrayIfyActivityIds(
						$elem.attr("data-unread-activity-ids"),
					);
					if (!thisData.includes(activityId)) {
						// Prevent duplicates of Activity ids
						thisData = thisData.concat(activityId);
					}
					// pp.log("marking el", $elem, activityId, props, thisData);
					$elem.attr("data-unread-activity-ids", thisData);
				});
			});
		});
	},

	queueActivitiesRead: (activityIds) => {
		activityIds = pp.activities.arrayIfyActivityIds(activityIds);

		if (!activityIds.length) {
			return;
		}

		// pp.log("ACTIVITIES queueing as read -- Activity ids", activityIds);

		// add to readActivityIds -- do this before the actual request in case fetchAllUnreadActivities is called while this function hasn't finished yet
		for (let i = 0; i < activityIds.length; i++) {
			const thisActivityId = activityIds[i];
			if (
				// @ts-expect-error
				pp.activities.readActivityIds.includes(thisActivityId) ||
				// @ts-expect-error
				pp.activities.setReadQueue.includes(thisActivityId)
			) {
				pp.activities.unmarkReadElements(thisActivityId);
				continue;
			}

			// @ts-expect-error
			pp.activities.setReadQueue.push(thisActivityId);
			if (!pp.activities.setReadTriggerListener) {
				pp.activities.setReadTriggerListener = $(document).one(
					"page:change ajax:success",
					pp.activities.setActivitiesRead,
				);
			}

			// always clear in case there are more Activity ids coming in
			clearTimeout(pp.activities.setReadTimeout);
			pp.activities.setReadTimeout = setTimeout(
				pp.activities.setActivitiesRead,
				250,
			);
		}
	},

	setActivitiesRead: (event) => {
		pp.log(
			"ACTIVITIES setting read -- Activity ids",
			pp.activities.setReadQueue,
		);

		$(document).off(
			"page:change ajax:success",
			pp.activities.setActivitiesRead,
		);
		pp.activities.setReadTriggerListener = null;
		clearTimeout(pp.activities.setReadTimeout); // always clear in case the function was called from the listener
		// Always work with a copy in case another (new) timeout is already being set in queueActivitiesRead
		const toSetWithThisRequest = Object.assign([], pp.activities.setReadQueue);

		$.ajax({
			url: "/activities/set_read",
			type: "PUT",
			data: { activity_ids: toSetWithThisRequest },
		})
			// @ts-expect-error
			.success((msg) => {
				// @ts-expect-error
				pp.activities.readActivityIds.concat(toSetWithThisRequest);

				const newActivitiesData = Object.assign(
					{},
					pp.activities.unreadActivitiesData,
				);

				for (let i = 0; i < toSetWithThisRequest.length; i++) {
					const thisActivityId = toSetWithThisRequest[i];
					pp.activities.unmarkReadElements(thisActivityId);
					delete newActivitiesData[thisActivityId];
				}
				pp.activities.unreadActivitiesData = newActivitiesData;
				pp.activities.setReadQueue = pp.activities.setReadQueue.filter(
					(item) => {
						return toSetWithThisRequest.indexOf(item) == -1;
					},
				);
			})
			.fail(() => {
				pp.log("ACTIVITIES could not update Activity read status on server");
			});
	},

	/**
	 * Remove an Activity id from all the elements that might be marked with it
	 */
	unmarkReadElements: (activityId) => {
		// pp.log("ACTIVITIES unmarking Activity ids:", activityId);
		$(`[data-unread-activity-ids*='${activityId}']`).each((index, elem) => {
			// pp.log("- at", elem);
			let thisData = pp.activities.arrayIfyActivityIds(
				$(elem).attr("data-unread-activity-ids"),
			);

			if (!thisData) {
				console.error("No unread Activity ids found", elem);
				return;
			}

			thisData.splice(thisData.indexOf(activityId), 1);
			if (thisData.length) {
				$(elem).attr("data-unread-activity-ids", thisData);
			} else {
				$(elem).removeAttr("data-unread-activity-ids");
			}
		});
	},

	arrayIfyActivityIds: (activityIds) => {
		// Parse the read attribute (from `attr('data-unread-activity-ids')`) to an array
		if (activityIds === undefined) {
			return [];
		} else if (typeof activityIds === "object") {
			// is an array already
			return activityIds;
		} else if (typeof activityIds === "string") {
			if (activityIds.includes("[")) {
				return eval(activityIds);
			} else {
				return eval("[" + activityIds + "]");
			}
		} else if (typeof activityIds === "number") {
			// for single Activity ids
			return [activityIds];
		} else {
			console.error("Unparseable activityIds arg:", activityIds);
			return [];
		}
	},
};
